import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import AddTask from "./components/TaskForm/AddTask";
import EditTask from "./components/TaskForm/EditTask";
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <Navbar />
      <div className="container relative">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/add-task" element={<AddTask />} />
          <Route path="/edit-task/:taskId" element={<EditTask />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
